var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLogged)?_c('div',{on:{"click":_vm.handleLogin}},[_vm._t("login-action",function(){return [_c('v-btn',{attrs:{"text":"","color":"primary"}},[_vm._v(" "+_vm._s(_vm.$t("common.login"))+" ")])]})],2):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }